import { Component, Input, OnInit } from '@angular/core';
import { ImportTmsLoadsResult } from '../../shared/tms-import/import-tms-loads-result';
import { ImportTmsLoadType } from '../../shared/tms-import/import-tms-load-result';

@Component({
  selector: 'app-tms-import-result',
  templateUrl: './tms-import-result.component.html',
  styleUrls: ['./tms-import-result.component.scss']
})
export class TmsImportResultComponent implements OnInit {

  @Input()
  result: ImportTmsLoadsResult;

  ImportTmsLoadType = ImportTmsLoadType;

  constructor() {
  }

  ngOnInit() {
  }

}
